export const fmStates = [{ value: 'FM', label: 'FM' }]
